import { render } from "./UserPage.vue?vue&type=template&id=c0b99666&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/UserPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0b99666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0b99666', __exports__)) {
    api.reload('c0b99666', __exports__)
  }
  
  module.hot.accept("./UserPage.vue?vue&type=template&id=c0b99666&ts=true", () => {
    api.rerender('c0b99666', render)
  })

}


export default __exports__